import type { WorkItem } from "@baton/api";
import { create } from "zustand";
import type { Closing } from "./closeReason.ts";

/**
 * The open question of the one close-reason dialog the shell mounts (001 FR-161,
 * `CloseReasonDialog.tsx`), which `askCloseReason` of `closeReason.ts` asks. The shell reads it to
 * load the dialog on its first opening, so it is a module of its own, apart from the closure's
 * rules (FR-015-120, 2026-10-05).
 */
interface Question {
  /** The tasks the write cancels, which the dialog names by title; the identifiers key the dialog's form, so a new question starts it afresh. */
  readonly items: readonly Pick<WorkItem, "identifier" | "title">[];
  readonly answer: (closing: Closing | null) => void;
}

interface CloseReasonState {
  readonly question: Question | null;
  readonly ask: (question: Question) => void;
  readonly settle: (closing: Closing | null) => void;
}

export const useCloseReasonStore = create<CloseReasonState>((set, get) => ({
  question: null,
  ask: (question) => {
    // A question already open is answered "no" first, so no write waits on a dialog that is gone.
    get().question?.answer(null);
    set({ question });
  },
  settle: (closing) => {
    const open = get().question;
    set({ question: null });
    open?.answer(closing);
  },
}));
